import WebCrossIcon from "../../../../assets/PickUp/ModalCrossWeb.svg";
import TaskSquareIcon from "../../../../assets/task-square.svg";
import OneButton from "../../../../components/Button/OneButton";

const UNICOMMERCE_INTEGRATION_GUIDE_URL =
  "https://shipyaari.freshdesk.com/support/solutions/articles/1070000113363-how-do-i-integrate-unicommerce-with-shipyaari";

const UNICOMMERCE_DASHBOARD_URL =
  "https://dashboard.unicommerce.com/connect/login";

interface UnicommerceIntegrationModalProps {
  onClose: () => void;
}

const UnicommerceIntegrationModal = ({
  onClose,
}: UnicommerceIntegrationModalProps) => {
  const handleAddNewChannel = () => {
    window.location.href = UNICOMMERCE_DASHBOARD_URL;
  };

  return (
    <div className="flex flex-col h-full p-6">
      {/* Header */}
      <div className="flex justify-between items-start mb-6">
        <div className="flex items-center gap-3">
          <img
            src={TaskSquareIcon}
            alt=""
            className="w-6 h-6"
            aria-hidden
          />
          <h2 className="text-2xl font-normal text-[#1C1C1C]">
            Integrate Unicommerce
          </h2>
        </div>
        <button
          onClick={onClose}
          className="p-1 hover:bg-gray-100 rounded cursor-pointer transition-colors"
          aria-label="Close modal"
        >
          <img src={WebCrossIcon} alt="" className="w-6 h-6" />
        </button>
      </div>

      {/* Content Section */}
      <div className="flex-1 flex flex-col justify-between">
        <div className="bg-[#F5F7FA] rounded-lg p-6 mb-6">
          <h3 className="font-bold text-[#1C1C1C] text-lg mb-2">
            Integrate your Unicommerce channel
          </h3>
          <p className="text-[#4A4A4A] text-sm leading-relaxed">
            <a
              href={UNICOMMERCE_INTEGRATION_GUIDE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#004EFF] font-medium hover:underline"
            >
              Click here
            </a>{" "}
            to view the step-by-step guide for integrating Unicommerce with
            Shipyaari.
          </p>
        </div>
        {/* <OneButton
          text="ADD NEW CHANNEL"
          onClick={handleAddNewChannel}
          variant="primary"
          className="w-full py-3"
          textTransform="uppercase"
        /> */}
      </div>
    </div>
  );
};

export default UnicommerceIntegrationModal;
